import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconPlay = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <polygon points="75.955,50.569 28.045,77.649 28.045,23.49"/>
    </svg>
);

export default IconPlay;